import axios, { AxiosRequestConfig } from 'axios';
import {
  reportRequestFailure,
  reportRequestSuccess,
} from '../components/alliance/connection-monitor';
import { reportAppAccess } from './app-access';

/** True when a request went to the University API (not Contracting etc.) */
const isUniversityRequest = (params: { config?: AxiosRequestConfig }) => {
  const base = process.env.REACT_APP_UNIVERSITY_API_URL;
  const url = params.config?.url || '';
  return Boolean(base) && url.startsWith(base as string);
};

/**
 * Watch every API call. Amplify's API module sends its requests through the
 * default axios instance (as does utils/form-data-request.ts), so one
 * response interceptor sees the react-query calls and the admin useEffect
 * ones alike. It feeds:
 *
 * - the connection banner (only network errors and 5xx count)
 * - the app-level no-access screen (University API 403s vs. successes)
 *
 * Cancelled requests are ignored.
 */
export function installRequestMonitor() {
  axios.interceptors.response.use(
    (response) => {
      reportRequestSuccess();
      if (isUniversityRequest({ config: response.config })) {
        reportAppAccess({ status: response.status });
      }
      return response;
    },
    (error) => {
      if (!axios.isCancel(error)) {
        reportRequestFailure(error);
        if (isUniversityRequest({ config: error?.config })) {
          reportAppAccess({ status: error?.response?.status });
        }
      }
      return Promise.reject(error);
    },
  );
}
